import { offer } from '../data/offer'

export const OFFER_ANCHOR = '#offer'

export const PREVIEW_ANCHOR = '#extraits'

export const CTA_LABEL = 'DÉCOUVRIR LA COLLECTION'

export const PREVIEW_LINK_LABEL = 'FEUILLETER LES EXTRAITS'

export const CHECKOUT_LABEL = 'ACCÉDER À LA COLLECTION'

export const PENDING_CHECKOUT_LABEL = 'BIENTÔT DISPONIBLE'

/** The sale price is public as soon as price and currency are confirmed, independently of checkout. */
export function isPriceKnown(): boolean {
  return offer.price !== null && offer.currency !== null
}

/** Purchase is only possible once the price is known AND a checkout URL exists. */
export function isCheckoutReady(): boolean {
  return isPriceKnown() && offer.checkoutUrl !== null
}

/** Indicative bonus values are shown only once confirmed separately from the sale price. */
export function areBonusValuesPublic(): boolean {
  return offer.currency !== null && offer.bonusValuesConfirmed
}

/** Formatted sale price (e.g. « 19 € »), or null while unknown. */
export function formattedPrice(): string | null {
  return isPriceKnown() && offer.price !== null ? formatAmount(offer.price) : null
}

/** Formats an amount in French; adds the currency only once it is confirmed. */
export function formatAmount(amount: number): string {
  if (!offer.currency) return new Intl.NumberFormat('fr-FR').format(amount)
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: offer.currency,
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount)
}
